import { type Components, type Theme } from "@mui/material";

export const MuiMenuItem: Components<Theme>["MuiMenuItem"] = {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(1),
      minHeight: "0px",
      "&:hover": {
        backgroundColor: theme.palette.grey[50],
      },
      "&.Mui-focusVisible": {
        backgroundColor: theme.palette.grey[100],
        outline: `2px solid ${theme.palette.primary.main}`,
        outlineOffset: "-2px",
      },
      "&.Mui-selected": {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.primary.contrastText,
        "&:hover": {
          backgroundColor: theme.palette.primary.light,
        },
      },
      "& .MuiListItemIcon-root": {
        minWidth: "0px",
        paddingRight: theme.spacing(2),
        color: theme.palette.text.secondary,
      },
    }),
  },
};
